module.exports = __webpack_public_path__ + "img/m_event_page2.299310be.png";